/**
 * Created by RanAn on 2021/05/01.
 */
/* jshint esversion: 8 */
import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import HistoryMain from '@/components/HistoryMain.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: "login",
      component: () => import('./views/Login.vue')
    },
    {
      path: '/home',
      name: 'home',
      component: Home,
      children:[{
        path: '/',
        component: HistoryMain
      }],
      beforeEnter:((to, from, next) => {
        if(sessionStorage.getItem("token") || sessionStorage.getItem("user_id")
         || sessionStorage.getItem("app_link") || sessionStorage.getItem("login_id")){
          next();
        }else{
          next('/')
        }    
      })
    },
    
    {
      path: '*',
      redirect: "/"
    }
  ],
  mode: 'history'
});
